import React, { Component } from 'react';
import { ErrorMessage, Field, getIn } from 'formik';
import axios from 'axios';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import { builderSurfaceJsonContentHeader } from '../../../../common/utils/restApiHeaderUtils';
import ItemFormCustomSelect from '../../../../common/formElements/ItemFormCustomSelect';
import { iconForField } from '../../../../common/custom/icon-library';
import { CUSTOM_SEPARATOR } from '../../../../common/utils/field-options';

class DynamicOptions extends Component {
  state = { referenceItems: [], options: [] };

  requiredValidate = (value) => {
    if (this.props.isConstructorForm) {
      return;
    }
    const { required } = this.props.field;
    let error;
    if (required && (!value || value.length === 0)) {
      error = 'This field is required';
    }
    return error;
  };
  componentDidMount() {
    const { projectId, field, version } = this.props;
    if (!field.refCollection) {
      return;
    }

    const { refCollection } = field;
    const { collectionField, collectionName } = refCollection || '';
    let refCollectionName = collectionName;
    if (collectionField && collectionField.includes(CUSTOM_SEPARATOR)) {
      let refCollectionMeta = collectionField.split(CUSTOM_SEPARATOR);
      refCollectionName = refCollectionMeta[0];
    }

    const header = builderSurfaceJsonContentHeader(projectId);
    axios
      .get(`${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${refCollectionName}/`, header)
      .then((res) => {
        let options1 = [];
        if (Array.isArray(res.data)) {
          res.data.forEach((item) => {
            const isChildRefField = this.props.field.refCollection.collectionField
              ? this.props.field.refCollection.collectionField.includes('.')
              : false;
            let refCollectionFieldName = this.props.field.refCollection.collectionField;

            if (isChildRefField) {
              let refChildColField = this.props.field.refCollection.collectionField.split('.');
              refCollectionFieldName = refChildColField[1];
            }

            const itemData = _.get(item, refCollectionFieldName);

            if (itemData) {
              let itemLabel = itemData;
              let itemValue = itemData;
              if (itemData && itemData.includes('::')) {
                const itemArr = itemData.split('::');
                if (itemArr && itemArr.length === 2) {
                  itemValue = itemArr[0].trim();
                  itemLabel = itemArr[1].trim();
                }
              }

              options1.push({
                value: itemValue,
                label: itemLabel,
              });
            }
          });
        }
        const options = [{ value: '', label: '-- Select Value --' }].concat(options1);
        this.setState({ options });
      });
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (!nextProps.field.refCollection) {
      return;
    }
  }

  render() {
    const { field, values, isConstructorForm } = this.props;
    const { fieldTitle, required, fieldName, isMultiSelect } = field;
    const fieldValue = getIn(values, fieldName);
    return (
      <>
        {/* <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
          <div className="form-group">
            <div className="input-group">
              <div className="input-group-prepend" title={fieldTitle['en']}>
                <span className="input-group-text">
                  <i className={`wb ${iconForField(field.type)}`}></i>
                  <span className="required">{required && !isConstructorForm ? ' *' : ''}</span>
                </span>
              </div> */}
        <Field
          as={ItemFormCustomSelect}
          name={fieldName}
          isMulti={isMultiSelect}
          onChange={this.props.setFieldValue}
          onBlur={this.props.setFieldTouched}
          options={this.state.options.length > 0 ? this.state.options : []}
          placeholder={`Please select an ${fieldTitle['en']}`}
          value={fieldValue || []}
          validate={this.requiredValidate}
          title={fieldTitle['en']}
        />
        <p className="errors">
          <ErrorMessage name={fieldName} />
        </p>
        {/* </div>
          </div>
        </div> */}
      </>
    );
  }
}

export default DynamicOptions;
